import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { RegenerateTokenRequest } from './regeneratetokenrequest';

export class RegenerateTokenAPI extends SixdeeCRBTAPI<RegenerateTokenRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/regen-token
        return "regen-token";
    }

    getRequestData()
    {
        return "refreshToken=" + this.getRequest().getRegenerateTokenRequest().getRefreshToken();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/regeneratetoken/regeneratetokenapi.tsx